module.exports = __webpack_public_path__ + "static/aragon-3Dscreen-f9ec4e9da6bfcbf359ac6e5f3a7c989a.png";